<template>
  <header
    id="top"
    class="header"
    :class="{ navbar_sticky: navStickyState }"
  >
    <nav
      ref="nav"
      class="navbar container"
    >
      <client-only>
        <HeaderContent />
      </client-only>
    </nav>
  </header>
</template>

<script setup lang="ts">
// Lightweight component that just renders the header
// The heavy content is loaded client-side only
import { onBeforeUnmount, onMounted, ref } from 'vue';

const navStickyState = ref(false);

// Only set up simple scroll behavior directly in this component
// The rest is in the client component
onMounted(() => {
  if (typeof window !== 'undefined') {
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
  }
});

onBeforeUnmount(() => {
  if (typeof window !== 'undefined') {
    window.removeEventListener('scroll', handleScroll);
  }
});

function handleScroll() {
  navStickyState.value = window.scrollY > 10;
}
</script>

<style scoped lang="scss">
@import '../assets/variables';

.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  display: block;
  width: 100%;
  transition: 0.2s all ease-in-out;
}

.navbar {
  z-index: 1000;
  position: fixed;
  left: calc((100vw - 100%) / 2 + 50%);
  translate: -50%;
  top: 16px;
  width: 100%;

  @include media-breakpoint-down(sm) {
    padding-left: 4px;
    padding-right: 4px;
    top: 4px;
  }
}

.navbar_sticky {
  &.header {
    background: white;
    box-shadow: 0 4px 20px rgb(80 71 230 / 5%);
  }

  .navbar__content {
    box-shadow: 0 4px 40px #00000017;
  }
}

@keyframes header-sticky-in {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}
</style>
